/**
 * VX/Elite Vergleichstexte für den Payment-Bereich.
 * Wird in i18n/index.ts in alle Locales gemerged.
 */
const en = {
    versionExplainer: {
        toggle: 'VX or Elite? Which version is right for me?',
        note: 'These are two separate, standalone versions. A VX activation code does NOT unlock the Elite version, and vice versa.',
        vx: {
            tag: 'All devices',
            title: 'VX Version',
            point1: 'Runs on all supported watches',
            point2: 'Free trial, then unlock with a purchased code',
            point3: 'Code is bound to one device',
        },
        elite: {
            tag: 'Garmin Pay',
            title: 'Elite Version',
            point1: 'One-time purchase via Garmin Pay',
            point2: 'Bound to your Garmin account, not a single device',
            point3: 'Only on watches that support Garmin Pay',
        },
    },
    payment: {
        twoVersionsTitle: 'Two separate versions – choose one',
        versionSelectHint: 'VX and Elite are two different products. Pick the version that matches how you want to buy and unlock:',
    },
};
const de = {
    versionExplainer: {
        toggle: 'VX oder Elite? Welche Version passt zu mir?',
        note: 'Das sind zwei getrennte, eigenständige Versionen. Ein VX-Freischaltcode schaltet NICHT die Elite-Version frei – und umgekehrt.',
        vx: {
            tag: 'Alle Geräte',
            title: 'VX-Version',
            point1: 'Läuft auf allen unterstützten Uhren',
            point2: 'Kostenlose Testphase, danach Freischaltung per gekauftem Code',
            point3: 'Der Code ist an ein Gerät gebunden',
        },
        elite: {
            tag: 'Garmin Pay',
            title: 'Elite-Version',
            point1: 'Einmalkauf über Garmin Pay',
            point2: 'An dein Garmin-Konto gebunden, nicht an ein einzelnes Gerät',
            point3: 'Nur auf Uhren, die Garmin Pay unterstützen',
        },
    },
    payment: {
        twoVersionsTitle: 'Zwei getrennte Versionen – wähle eine',
        versionSelectHint: 'VX und Elite sind zwei unterschiedliche Produkte. Wähle die Version, die zu deiner Kauf- und Freischaltart passt:',
    },
};
const fr = {
    versionExplainer: {
        toggle: 'VX ou Elite ? Quelle version me convient ?',
        note: 'Ce sont deux versions distinctes et autonomes. Un code d’activation VX ne déverrouille PAS la version Elite, et inversement.',
        vx: {
            tag: 'Tous les appareils',
            title: 'Version VX',
            point1: 'Fonctionne sur toutes les montres prises en charge',
            point2: 'Essai gratuit, puis déverrouillage avec un code acheté',
            point3: 'Le code est lié à un seul appareil',
        },
        elite: {
            tag: 'Garmin Pay',
            title: 'Version Elite',
            point1: 'Achat unique via Garmin Pay',
            point2: 'Lié à votre compte Garmin, pas à un seul appareil',
            point3: 'Uniquement sur les montres compatibles Garmin Pay',
        },
    },
    payment: {
        twoVersionsTitle: 'Deux versions distinctes – choisissez-en une',
        versionSelectHint: 'VX et Elite sont deux produits différents. Choisissez la version selon le mode d’achat et de déverrouillage :',
    },
};
const es = {
    versionExplainer: {
        toggle: '¿VX o Elite? ¿Qué versión me conviene?',
        note: 'Son dos versiones independientes y separadas. Un código de activación VX NO desbloquea la versión Elite, y viceversa.',
        vx: {
            tag: 'Todos los dispositivos',
            title: 'Versión VX',
            point1: 'Funciona en todos los relojes compatibles',
            point2: 'Prueba gratuita y luego desbloqueo con un código comprado',
            point3: 'El código está vinculado a un dispositivo',
        },
        elite: {
            tag: 'Garmin Pay',
            title: 'Versión Elite',
            point1: 'Compra única mediante Garmin Pay',
            point2: 'Vinculada a tu cuenta Garmin, no a un solo dispositivo',
            point3: 'Solo en relojes compatibles con Garmin Pay',
        },
    },
    payment: {
        twoVersionsTitle: 'Dos versiones separadas – elige una',
        versionSelectHint: 'VX y Elite son dos productos distintos. Elige la versión según cómo quieras comprar y desbloquear:',
    },
};
const it = {
    versionExplainer: {
        toggle: 'VX o Elite? Quale versione fa per me?',
        note: 'Sono due versioni separate e autonome. Un codice di attivazione VX NON sblocca la versione Elite, e viceversa.',
        vx: {
            tag: 'Tutti i dispositivi',
            title: 'Versione VX',
            point1: 'Funziona su tutti gli orologi supportati',
            point2: 'Prova gratuita, poi sblocco con un codice acquistato',
            point3: 'Il codice è legato a un singolo dispositivo',
        },
        elite: {
            tag: 'Garmin Pay',
            title: 'Versione Elite',
            point1: 'Acquisto una tantum tramite Garmin Pay',
            point2: 'Legata al tuo account Garmin, non a un singolo dispositivo',
            point3: 'Solo su orologi compatibili con Garmin Pay',
        },
    },
    payment: {
        twoVersionsTitle: 'Due versioni separate – scegline una',
        versionSelectHint: 'VX ed Elite sono due prodotti diversi. Scegli la versione in base a come vuoi acquistare e sbloccare:',
    },
};
const pt = {
    versionExplainer: {
        toggle: 'VX ou Elite? Qual versão é a certa para mim?',
        note: 'São duas versões separadas e autónomas. Um código de ativação VX NÃO desbloqueia a versão Elite, e vice-versa.',
        vx: {
            tag: 'Todos os dispositivos',
            title: 'Versão VX',
            point1: 'Funciona em todos os relógios suportados',
            point2: 'Teste gratuito e depois desbloqueio com um código comprado',
            point3: 'O código fica ligado a um dispositivo',
        },
        elite: {
            tag: 'Garmin Pay',
            title: 'Versão Elite',
            point1: 'Compra única via Garmin Pay',
            point2: 'Ligada à sua conta Garmin, não a um único dispositivo',
            point3: 'Apenas em relógios compatíveis com Garmin Pay',
        },
    },
    payment: {
        twoVersionsTitle: 'Duas versões separadas – escolha uma',
        versionSelectHint: 'VX e Elite são dois produtos diferentes. Escolha a versão conforme a forma de compra e desbloqueio:',
    },
};
const nl = {
    versionExplainer: {
        toggle: 'VX of Elite? Welke versie past bij mij?',
        note: 'Dit zijn twee aparte, zelfstandige versies. Een VX-activeringscode ontgrendelt NIET de Elite-versie, en omgekeerd.',
        vx: {
            tag: 'Alle apparaten',
            title: 'VX-versie',
            point1: 'Werkt op alle ondersteunde horloges',
            point2: 'Gratis proefperiode, daarna ontgrendelen met een gekochte code',
            point3: 'De code is gekoppeld aan één apparaat',
        },
        elite: {
            tag: 'Garmin Pay',
            title: 'Elite-versie',
            point1: 'Eenmalige aankoop via Garmin Pay',
            point2: 'Gekoppeld aan je Garmin-account, niet aan één apparaat',
            point3: 'Alleen op horloges die Garmin Pay ondersteunen',
        },
    },
    payment: {
        twoVersionsTitle: 'Twee aparte versies – kies er één',
        versionSelectHint: 'VX en Elite zijn twee verschillende producten. Kies de versie die past bij hoe je wilt kopen en ontgrendelen:',
    },
};
const pl = {
    versionExplainer: {
        toggle: 'VX czy Elite? Która wersja jest dla mnie?',
        note: 'To dwie osobne, niezależne wersje. Kod aktywacyjny VX NIE odblokowuje wersji Elite i odwrotnie.',
        vx: {
            tag: 'Wszystkie urządzenia',
            title: 'Wersja VX',
            point1: 'Działa na wszystkich obsługiwanych zegarkach',
            point2: 'Bezpłatny okres próbny, potem odblokowanie kupionym kodem',
            point3: 'Kod jest powiązany z jednym urządzeniem',
        },
        elite: {
            tag: 'Garmin Pay',
            title: 'Wersja Elite',
            point1: 'Jednorazowy zakup przez Garmin Pay',
            point2: 'Powiązana z kontem Garmin, nie z jednym urządzeniem',
            point3: 'Tylko na zegarkach obsługujących Garmin Pay',
        },
    },
    payment: {
        twoVersionsTitle: 'Dwie oddzielne wersje – wybierz jedną',
        versionSelectHint: 'VX i Elite to dwa różne produkty. Wybierz wersję zgodnie z tym, jak chcesz kupić i odblokować:',
    },
};
const cs = {
    versionExplainer: {
        toggle: 'VX nebo Elite? Která verze je pro mě?',
        note: 'Jsou to dvě samostatné, oddělené verze. Aktivační kód VX NEODEMYKÁ verzi Elite a naopak.',
        vx: {
            tag: 'Všechna zařízení',
            title: 'Verze VX',
            point1: 'Běží na všech podporovaných hodinkách',
            point2: 'Bezplatná zkušební doba, poté odemčení zakoupeným kódem',
            point3: 'Kód je vázán na jedno zařízení',
        },
        elite: {
            tag: 'Garmin Pay',
            title: 'Verze Elite',
            point1: 'Jednorázový nákup přes Garmin Pay',
            point2: 'Vázáno na váš účet Garmin, ne na jedno zařízení',
            point3: 'Pouze na hodinkách s podporou Garmin Pay',
        },
    },
    payment: {
        twoVersionsTitle: 'Dvě samostatné verze – vyberte jednu',
        versionSelectHint: 'VX a Elite jsou dva různé produkty. Vyberte verzi podle toho, jak chcete nakoupit a odemknout:',
    },
};
const ja = {
    versionExplainer: {
        toggle: 'VX と Elite、どちらが自分に合う？',
        note: 'これらは別々の独立したバージョンです。VX のアクティベーションコードでは Elite 版は解除されず、その逆も同様です。',
        vx: {
            tag: 'すべてのデバイス',
            title: 'VX バージョン',
            point1: '対応するすべての時計で動作',
            point2: '無料トライアル後、購入したコードで解除',
            point3: 'コードは1台のデバイスに紐づく',
        },
        elite: {
            tag: 'Garmin Pay',
            title: 'Elite バージョン',
            point1: 'Garmin Pay での一回買い切り',
            point2: 'Garmin アカウントに紐づき、1台限定ではない',
            point3: 'Garmin Pay 対応の時計のみ',
        },
    },
    payment: {
        twoVersionsTitle: '2つの別バージョン – どちらかを選択',
        versionSelectHint: 'VX と Elite は別製品です。購入・解除の方法に合うバージョンを選んでください：',
    },
};
const ko = {
    versionExplainer: {
        toggle: 'VX 또는 Elite? 어떤 버전이 맞나요?',
        note: '서로 다른 독립 버전입니다. VX 활성화 코드로는 Elite 버전이 잠금 해제되지 않으며, 그 반대도 마찬가지입니다.',
        vx: {
            tag: '모든 기기',
            title: 'VX 버전',
            point1: '지원되는 모든 시계에서 작동',
            point2: '무료 체험 후 구매한 코드로 잠금 해제',
            point3: '코드는 한 기기에 연결됨',
        },
        elite: {
            tag: 'Garmin Pay',
            title: 'Elite 버전',
            point1: 'Garmin Pay로 한 번 구매',
            point2: 'Garmin 계정에 연결되며 단일 기기에 한정되지 않음',
            point3: 'Garmin Pay를 지원하는 시계에서만',
        },
    },
    payment: {
        twoVersionsTitle: '두 개의 별도 버전 – 하나를 선택하세요',
        versionSelectHint: 'VX와 Elite는 서로 다른 제품입니다. 구매 및 잠금 해제 방식에 맞는 버전을 선택하세요:',
    },
};
const zh = {
    versionExplainer: {
        toggle: 'VX 还是 Elite？哪个版本适合我？',
        note: '这是两个独立的版本。VX 激活码无法解锁 Elite 版本，反之亦然。',
        vx: {
            tag: '所有设备',
            title: 'VX 版本',
            point1: '可在所有受支持的手表上运行',
            point2: '免费试用后，用购买的代码解锁',
            point3: '代码绑定到一台设备',
        },
        elite: {
            tag: 'Garmin Pay',
            title: 'Elite 版本',
            point1: '通过 Garmin Pay 一次性购买',
            point2: '绑定到您的 Garmin 账户，而非单台设备',
            point3: '仅适用于支持 Garmin Pay 的手表',
        },
    },
    payment: {
        twoVersionsTitle: '两个独立版本 – 请选择一个',
        versionSelectHint: 'VX 与 Elite 是两个不同的产品。请按您的购买和解锁方式选择版本：',
    },
};
const ru = {
    versionExplainer: {
        toggle: 'VX или Elite? Какая версия мне подходит?',
        note: 'Это две отдельные, самостоятельные версии. Код активации VX НЕ разблокирует версию Elite, и наоборот.',
        vx: {
            tag: 'Все устройства',
            title: 'Версия VX',
            point1: 'Работает на всех поддерживаемых часах',
            point2: 'Бесплатный пробный период, затем разблокировка купленным кодом',
            point3: 'Код привязан к одному устройству',
        },
        elite: {
            tag: 'Garmin Pay',
            title: 'Версия Elite',
            point1: 'Разовая покупка через Garmin Pay',
            point2: 'Привязана к аккаунту Garmin, а не к одному устройству',
            point3: 'Только на часах с поддержкой Garmin Pay',
        },
    },
    payment: {
        twoVersionsTitle: 'Две отдельные версии – выберите одну',
        versionSelectHint: 'VX и Elite — это разные продукты. Выберите версию в зависимости от способа покупки и разблокировки:',
    },
};
const uk = {
    versionExplainer: {
        toggle: 'VX чи Elite? Яка версія мені підходить?',
        note: 'Це дві окремі, самостійні версії. Код активації VX НЕ розблоковує версію Elite, і навпаки.',
        vx: {
            tag: 'Усі пристрої',
            title: 'Версія VX',
            point1: 'Працює на всіх підтримуваних годинниках',
            point2: 'Безкоштовний пробний період, потім розблокування купленим кодом',
            point3: 'Код прив’язаний до одного пристрою',
        },
        elite: {
            tag: 'Garmin Pay',
            title: 'Версія Elite',
            point1: 'Одноразова покупка через Garmin Pay',
            point2: 'Прив’язана до облікового запису Garmin, а не до одного пристрою',
            point3: 'Лише на годинниках з підтримкою Garmin Pay',
        },
    },
    payment: {
        twoVersionsTitle: 'Дві окремі версії – оберіть одну',
        versionSelectHint: 'VX і Elite — це різні продукти. Оберіть версію залежно від способу покупки та розблокування:',
    },
};
const no = {
    versionExplainer: {
        toggle: 'VX eller Elite? Hvilken versjon passer for meg?',
        note: 'Dette er to separate, selvstendige versjoner. En VX-aktiveringskode låser IKKE opp Elite-versjonen, og omvendt.',
        vx: {
            tag: 'Alle enheter',
            title: 'VX-versjon',
            point1: 'Kjører på alle støttede klokker',
            point2: 'Gratis prøveperiode, deretter opplåsing med kjøpt kode',
            point3: 'Koden er bundet til én enhet',
        },
        elite: {
            tag: 'Garmin Pay',
            title: 'Elite-versjon',
            point1: 'Engangskjøp via Garmin Pay',
            point2: 'Bundet til Garmin-kontoen din, ikke til én enhet',
            point3: 'Kun på klokker som støtter Garmin Pay',
        },
    },
    payment: {
        twoVersionsTitle: 'To separate versjoner – velg én',
        versionSelectHint: 'VX og Elite er to ulike produkter. Velg versjonen som matcher hvordan du vil kjøpe og låse opp:',
    },
};
const sv = {
    versionExplainer: {
        toggle: 'VX eller Elite? Vilken version passar mig?',
        note: 'Detta är två separata, fristående versioner. En VX-aktiveringskod låser INTE upp Elite-versionen, och tvärtom.',
        vx: {
            tag: 'Alla enheter',
            title: 'VX-version',
            point1: 'Fungerar på alla stödda klockor',
            point2: 'Gratis provperiod, därefter upplåsning med köpt kod',
            point3: 'Koden är bunden till en enhet',
        },
        elite: {
            tag: 'Garmin Pay',
            title: 'Elite-version',
            point1: 'Engångsköp via Garmin Pay',
            point2: 'Bunden till ditt Garmin-konto, inte till en enda enhet',
            point3: 'Endast på klockor som stöder Garmin Pay',
        },
    },
    payment: {
        twoVersionsTitle: 'Två separata versioner – välj en',
        versionSelectHint: 'VX och Elite är två olika produkter. Välj version utifrån hur du vill köpa och låsa upp:',
    },
};
export const VERSION_COMPARE_BY_LANG = {
    en,
    de,
    fr,
    es,
    it,
    pt,
    nl,
    pl,
    cs,
    ja,
    ko,
    zh,
    ru,
    uk,
    no,
    sv,
};
export const versionCompareEn = en;
